import * as React from "react";
import type { SVGProps } from "react";
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#refresh_svg__a)">
      <path d="M20.05 8.74h-4.74c-.55 0-1-.45-1-1s.45-1 1-1h3.74V3c0-.55.45-1 1-1s1 .45 1 1v4.74c0 .55-.45 1-1 1" />
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2c3.63 0 6.98 1.97 8.75 5.15.27.48.09 1.09-.39 1.36s-1.09.09-1.36-.39A8.01 8.01 0 0 0 12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8c0-.55.45-1 1-1s1 .45 1 1c0 5.51-4.49 10-10 10" />
    </g>
    <defs>
      <clipPath id="refresh_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRefresh;
